export default "__VITE_ASSET__1_6v5CwO__"